// @ts-ignore
// prettier-ignore
import { Modal,  Button,  connectModal } from '@gsa/afp-component-library';
import './OptionsCancelEditModal.scss';

const dataTestIdPrefix = 'options-cancel-edit-modal';

function OptionsCancelEditModal({ onClose, onConfirm }) {

  const Actions = ({ onClose, onConfirm }) => {
    return (
      <footer data-testid={`${dataTestIdPrefix}-footer`}>
        <div className="grid-row flex-row flex-align-center grid-gap-lg">
          <Button
            type="button"
            variant="unstyled"
            onClick={onClose}
            data-testid={`${dataTestIdPrefix}-cancel-btn`}
            label="Continue editing"
          />
          <Button
            type="button"
            variant="primary"
            onClick={onConfirm}
            data-testid={`${dataTestIdPrefix}-save-btn`}
            label="Cancel edit and return to review summary"
            leftIcon={{ name: 'check', type: 'custom' }}
          />
        </div>
      </footer>
    );
  };

  return (
    <Modal
      title={
        <>Confirm cancel.</>
      }
      variant="medium"
      onClose={onClose}
      actions={<Actions onClose={onClose} onConfirm={onConfirm} />}
      className="options-cancel-edit-modal"
    >
      <div className="modal-message usa-label">
        Are you sure you want to cancel?  Any changes you made will be discarded.
      </div>
    </Modal>
  );
}

export default connectModal(OptionsCancelEditModal);
